import React from "react";
import { PulseMark } from "@/components/brand/Logo";

export default function Splash() {
  const done = () => { try { sessionStorage.setItem("pulse_splashed", "1"); } catch (e) {} };
  return (
    <div
      className="splash-screen pointer-events-none fixed inset-0 z-[100] grid place-items-center bg-pulse-navy grain-overlay"
      data-testid="splash-screen"
      onAnimationEnd={done}
    >
      <div className="flex flex-col items-center gap-5">
        <div className="grid place-items-center rounded-2xl bg-white/5 p-6 heartbeat-anim">
          <PulseMark size={64} color="#FFFFFF" />
        </div>
        <div className="text-center">
          <div className="text-3xl font-bold tracking-tight text-white">Pulse</div>
          <div className="mt-1 text-sm font-medium text-white/50">The heartbeat of your business</div>
        </div>
      </div>
    </div>
  );
}
